import React, { Component } from "react";
import PropTypes from "prop-types";
import emoji from "node-emoji";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// styles
import styles from "./styles";

class Text extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { children, classes } = this.props;

    return (
      <span className={classes.font}>
        {children &&
          children.replace &&
          children.replace(/:\w+:/gi, (name) => emoji.get(name))}
      </span>
    );
  }
}

export default withStyles(styles)(Text);
